import { compose, defaultProps } from "recompact"
import { connect } from "react-redux"
import moment from "moment"
import memoize from "lodash/memoize"
import resourceModel from "src/models/resource"
import entityList from "src/hocs/entityList"
import EntityListEditor from "src/components/EntityListEditor"
import {
  RESOURCE_CREATE,
  RESOURCE_UPDATE,
  RESOURCE_DELETE,
} from "src/constants/knownPermissions"
import { ADMIN } from "src/constants/knownRoles"
import { hasPermission, hasRole } from "src/engine/modules/currentUser"
import queryString from "query-string"
import { RESOURCES_URL } from "src/constants/routeNames"
import Item, { FORM_NAME } from "./Item"
import FilterForm from "./Filter"

const closeModal = ({ history, queryParams }) => () => {
  history.push(`${RESOURCES_URL}?${queryString.stringify(queryParams)}`)
}

const columns = [
  {
    accessor: `name`,
    Header: `Наименование ресурса`,
    sortable: true,
    maxWidth: 548,
  },
  {
    accessor: `resourceTypeName`,
    sortable: true,
    Header: `Тип`,
    resizable: false,
  },
]

const columnsWithDeleted = [
  ...columns,
  {
    id: `deleteDate`,
    accessor: ({ deleteDate }) =>
      deleteDate ? moment(deleteDate).format(`DD.MM.YYYY HH:mm`) : ``,
    sortable: true,
    Header: `Дата удаления`,
    resizable: false,
  },
]

// Мемоизируем, чтобы не возвращалась каждый раз новая функция
// Чтобы в дальнейшем не делать лишних рендеров из-за изменений функции
const getCanDeleteFunction = memoize(canDeleteResources => data =>
  data.deleteDate ? false : canDeleteResources,
)

const enhancer = compose(
  connect(state => ({
    shouldSeeDeletedColumn: hasRole(ADMIN)(state) || false,
  })),
  entityList({
    model: resourceModel,
    ITEM_FORM_NAME: FORM_NAME,
    baseUri: RESOURCES_URL,
    columns: ({ shouldSeeDeletedColumn }) =>
      shouldSeeDeletedColumn ? columnsWithDeleted : columns,
    shouldHideDeleted: ({ shouldSeeDeletedColumn }) => !shouldSeeDeletedColumn,
  }),
  defaultProps({
    EntityEditor: compose(
      defaultProps({
        onCreate: closeModal,
        onUpdate: closeModal,
      }),
      connect(state => ({
        disableEdit: !hasPermission(RESOURCE_UPDATE)(state),
      })),
    )(Item),
    FilterEditor: FilterForm,
  }),
  connect(state => ({
    disableCreate: !hasPermission(RESOURCE_CREATE)(state),
    disableEdit: !hasPermission(RESOURCE_UPDATE)(state),
    disableDelete: !hasPermission(RESOURCE_DELETE)(state),
    canDelete: getCanDeleteFunction(hasPermission(RESOURCE_DELETE)(state)),
  })),
)

export default enhancer(EntityListEditor)
